// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ errorMessage: string }>;

export const DispatchSetErrorMessage: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/SetErrorMessage",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetErrorMessage];

const setErrorMessage = createHandlerChainRunner(chain, "SetErrorMessage");
export default setErrorMessage;
